// import React, { useState, useEffect } from "react";
// import { getData, serverURL, postData } from "../../../Services/Fetchnodeservices";

// // ===================== THEME =====================
// const getT = (isDark) => ({
//   bg: isDark ? "#0c1018" : "#f0f4ff",
//   surface: isDark ? "#141824" : "#ffffff",
//   surfaceAlt: isDark ? "#1c2133" : "#f4f7ff",
//   border: isDark ? "rgba(255,255,255,0.07)" : "#e2e8f5",
//   text: isDark ? "#f1f5f9" : "#0f172a",
//   textMuted: isDark ? "#64748b" : "#94a3b8",
//   textSub: isDark ? "#94a3b8" : "#64748b",
//   shadow: isDark ? "0 4px 28px rgba(0,0,0,0.45)" : "0 4px 28px rgba(99,102,241,0.10)",
//   shadowSm: isDark ? "0 2px 10px rgba(0,0,0,0.35)" : "0 2px 10px rgba(99,102,241,0.07)",
//   accent: "#6c63ff",
//   success: "#22c55e",
//   warning: "#f59e0b",
//   danger: "#ef4444",
//   info: "#3b82f6",
// });

// // ===================== ICONS =====================
// const SearchIcon = () => (
//   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <circle cx="11" cy="11" r="8" />
//     <line x1="21" y1="21" x2="16.65" y2="16.65" />
//   </svg>
// );

// const EditIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
//     <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
//   </svg>
// );

// const PlusIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <line x1="12" y1="5" x2="12" y2="19" />
//     <line x1="5" y1="12" x2="19" y2="12" />
//   </svg>
// );

// const CloseIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <line x1="18" y1="6" x2="6" y2="18" />
//     <line x1="6" y1="6" x2="18" y2="18" />
//   </svg>
// );

// const RefreshIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <path d="M23 4v6h-6" />
//     <path d="M1 20v-6h6" />
//     <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" />
//     <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14" />
//   </svg>
// );

// const FoodIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <path d="M12 2C10.5 2 9 3.5 9 5v2c0 1.5 1.5 3 3 3s3-1.5 3-3V5c0-1.5-1.5-3-3-3z" />
//     <path d="M12 10v12" />
//     <path d="M8 14h8" />
//   </svg>
// );

// const OthersIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <circle cx="12" cy="12" r="3" />
//     <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
//   </svg>
// );

// // ===================== COMPONENTS =====================
// const StatusBadge = ({ status, isDark }) => {
//   const t = getT(isDark);
//   const isActive = status === "1" || status === 1;
//   const config = isActive 
//     ? { bg: "rgba(34,197,94,0.15)", color: t.success, label: "Active" }
//     : { bg: "rgba(239,68,68,0.15)", color: t.danger, label: "Inactive" };
//   return (
//     <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: config.bg, color: config.color }}>
//       {config.label}
//     </span>
//   );
// };

// const Toast = ({ message, type, onClose, isDark }) => {
//   const t = getT(isDark);
//   return (
//     <div style={{ position: "fixed", bottom: "24px", right: "24px", zIndex: 1000, background: t.surface, border: `1px solid ${type === "error" ? t.danger : t.success}`, borderRadius: "12px", padding: "12px 20px", display: "flex", alignItems: "center", gap: "12px", boxShadow: t.shadow }}>
//       <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: type === "error" ? t.danger : t.success }} />
//       <span style={{ fontSize: "13px", color: type === "error" ? t.danger : t.success }}>{message}</span>
//       <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: t.textMuted }}><CloseIcon /></button>
//     </div>
//   );
// };

// // ===================== SUB-COMPONENT: CHARGE TABLE =====================
// const ChargeTable = ({ title, icon, charges, isDark, onEdit, onToggle, submitting, gstColor, gstPercentage }) => {
//   const t = getT(isDark);
  
//   const styles = {
//     sectionTitle: {
//       fontSize: "15px",
//       fontWeight: 600,
//       color: t.text,
//       padding: "12px 20px",
//       background: t.surfaceAlt,
//       borderBottom: `2px solid ${t.accent}`,
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//     },
//     table: {
//       width: "100%",
//       borderCollapse: "collapse",
//       minWidth: "750px",
//     },
//     th: {
//       padding: "12px 16px",
//       textAlign: "left",
//       fontSize: "11px",
//       fontWeight: 700,
//       color: t.accent,
//       borderBottom: `1px solid ${t.border}`,
//       background: t.surfaceAlt,
//     },
//     td: {
//       padding: "12px 16px",
//       fontSize: "13px",
//       color: t.textSub,
//       borderBottom: `1px solid ${t.border}`,
//     },
//     actionButtons: {
//       display: "flex",
//       gap: "8px",
//       alignItems: "center",
//       flexWrap: "wrap",
//     },
//     editBtn: {
//       padding: "5px 12px",
//       borderRadius: "8px",
//       border: "none",
//       fontSize: "11px",
//       fontWeight: 500,
//       cursor: "pointer",
//       background: t.info,
//       color: "#fff",
//     },
//     toggleBtn: (isActive) => ({
//       padding: "5px 12px",
//       borderRadius: "20px",
//       border: "none",
//       fontSize: "11px",
//       fontWeight: 500,
//       cursor: "pointer",
//       background: isActive ? t.success : t.warning,
//       color: "#fff",
//     }),
//     chargeValue: {
//       display: "inline-block",
//       padding: "4px 10px",
//       borderRadius: "20px",
//       background: t.accent + "15",
//       color: t.accent,
//       fontWeight: 600,
//       fontSize: "12px",
//     },
//     percentageValue: {
//       display: "inline-block",
//       padding: "4px 10px",
//       borderRadius: "20px",
//       background: "rgba(59, 130, 246, 0.15)",
//       color: t.info,
//       fontWeight: 600,
//       fontSize: "12px",
//     },
//     gstValue: {
//       display: "inline-block",
//       padding: "4px 10px",
//       borderRadius: "20px",
//       background: gstColor === "green" ? "rgba(34, 197, 94, 0.15)" : "rgba(245, 158, 11, 0.15)",
//       color: gstColor === "green" ? t.success : t.warning,
//       fontWeight: 600,
//       fontSize: "12px",
//     },
//     emptyState: {
//       textAlign: "center",
//       padding: "30px",
//       color: t.textMuted,
//       fontSize: "13px",
//     },
//     typeBadge: {
//       display: "inline-block",
//       padding: "2px 10px",
//       borderRadius: "12px",
//       fontSize: "10px",
//       fontWeight: 600,
//       background: title === "Food Items" ? "rgba(34, 197, 94, 0.15)" : "rgba(59, 130, 246, 0.15)",
//       color: title === "Food Items" ? t.success : t.info,
//     }
//   };

//   return (
//     <>
//       <div style={styles.sectionTitle}>
//         {icon} {title}
//         <span style={styles.typeBadge}>{charges.length} items</span>
//         <span style={{ 
//           marginLeft: "auto", 
//           fontSize: "11px", 
//           fontWeight: 400, 
//           color: t.textMuted,
//           background: gstColor === "green" ? "rgba(34, 197, 94, 0.1)" : "rgba(245, 158, 11, 0.1)",
//           padding: "2px 12px",
//           borderRadius: "12px"
//         }}>
//           GST: {gstPercentage}%
//         </span>
//       </div>
//       <table style={styles.table}>
//         <thead>
//           <tr>
//             <th style={styles.th}>SN</th>
//             <th style={styles.th}>ID</th>
//             <th style={styles.th}>Platform Fee</th>
//             <th style={styles.th}>Handling Charge</th>
//             <th style={styles.th}>Shipping Charge</th>
//             <th style={styles.th}>GST</th>
//             <th style={styles.th}>Status</th>
//             <th style={styles.th}>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {charges.length > 0 ? (
//             charges.map((charge, index) => (
//               <tr key={charge.id}>
//                 <td style={styles.td}>{index + 1}</td>
//                 <td style={styles.td}>{charge.id}</td>
//                 <td style={styles.td}>
//                   <span style={styles.chargeValue}>₹{parseFloat(charge.platform_fee || 0).toFixed(2)}</span>
//                 </td>
//                 <td style={styles.td}>
//                   <span style={styles.percentageValue}>
//                     {parseFloat(charge.handling_charge || 0).toFixed(2)}%
//                   </span>
//                 </td>
//                 <td style={styles.td}>
//                   <span style={styles.chargeValue}>₹{parseFloat(charge.shipping_charge || 0).toFixed(2)}</span>
//                 </td>
//                 <td style={styles.td}>
//                   <span style={styles.gstValue}>
//                     {parseFloat(charge.gst || 0).toFixed(2)}%
//                   </span>
//                 </td>
//                 <td style={styles.td}><StatusBadge status={charge.status} isDark={isDark} /></td>
//                 <td style={styles.td}>
//                   <div style={styles.actionButtons}>
//                     <button style={styles.editBtn} onClick={() => onEdit(charge)}>
//                       <EditIcon /> Edit
//                     </button>
//                     <button 
//                       style={styles.toggleBtn(charge.status === "1")} 
//                       onClick={() => onToggle(charge)}
//                       disabled={submitting}
//                     >
//                       {charge.status === "1" ? "Deactivate" : "Activate"}
//                     </button>
//                   </div>
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="8" style={styles.emptyState}>
//                 No {title.toLowerCase()} found
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </>
//   );
// };

// // ===================== MAIN COMPONENT - PLATFORM_FEE =====================
// const PlatformFee = ({ isDark = true }) => {
//   const t = getT(isDark);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
//   // ===== Platform Fee State =====
//   const [searchFee, setSearchFee] = useState("");
//   const [showFeeModal, setShowFeeModal] = useState(false);
//   const [editingFee, setEditingFee] = useState(null);
//   const [loadingFee, setLoadingFee] = useState(false);
//   const [submittingFee, setSubmittingFee] = useState(false);
//   const [platformFees, setPlatformFees] = useState([]);
//   const [feeFormData, setFeeFormData] = useState({
//     user_fee: "9",
//     driver_fee: "9",
//     business_fee: "0",
//     status: "1"
//   });

//   // ===== Platform Charges State =====
//   const [searchCharge, setSearchCharge] = useState("");
//   const [showChargeModal, setShowChargeModal] = useState(false);
//   const [editingCharge, setEditingCharge] = useState(null);
//   const [loadingCharge, setLoadingCharge] = useState(false);
//   const [submittingCharge, setSubmittingCharge] = useState(false);
//   const [platformCharges, setPlatformCharges] = useState([]);

//   const [chargeFormData, setChargeFormData] = useState({
//     platform_fee: "",
//     handling_charge: "",
//     shipping_charge: "",
//     gst: "5.00",
//     status: "1"
//   });

//   // ===== Toast State =====
//   const [toast, setToast] = useState(null);

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener('resize', handleResize);
//     fetchAllPlatformFees();
//     fetchPlatformCharges();
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const isMobile = windowWidth <= 768;

//   const showToast = (message, type = "success") => {
//     setToast({ message, type });
//     setTimeout(() => setToast(null), 3500);
//   };

//   // ===================== PLATFORM FEE FUNCTIONS =====================
//   const fetchAllPlatformFees = async () => {
//     setLoadingFee(true);
//     try {
//       const result = await getData("PlatformFee/fetch_all_platform_fee");
//       if (result.status) {
//         setPlatformFees(result.data);
//       } else {
//         showToast(result.message || "Failed to fetch platform fees", "error");
//       }
//     } catch (error) {
//       console.error("Fetch error:", error);
//       showToast("Network error while fetching platform fees", "error");
//     } finally {
//       setLoadingFee(false);
//     }
//   };

//   const handleOpenFeeModal = (fee = null) => {
//     if (fee) {
//       setEditingFee(fee);
//       setFeeFormData({
//         id: fee.id,
//         user_fee: fee.user_fee || "9",
//         driver_fee: fee.driver_fee || "9",
//         business_fee: fee.business_fee || "0",
//         status: fee.status || "1"
//       });
//     } else {
//       setEditingFee(null);
//       setFeeFormData({
//         user_fee: "9",
//         driver_fee: "9",
//         business_fee: "0",
//         status: "1"
//       });
//     }
//     setShowFeeModal(true);
//   };

//   const handleSaveFee = async () => {
//     if (!feeFormData.user_fee || !feeFormData.driver_fee) {
//       showToast("User Fee and Driver Fee are required", "error");
//       return;
//     }

//     setSubmittingFee(true);
    
//     try {
//       if (editingFee) {
//         const result = await postData("platformfee/update_platform_fee_status", { 
//           id: editingFee.id, 
//           status: feeFormData.status 
//         });
//         if (result.status) {
//           showToast("Platform fee status updated successfully");
//           fetchAllPlatformFees();
//           setShowFeeModal(false);
//         } else {
//           showToast(result.message || "Update failed", "error");
//         }
//       } else {
//         showToast("Add endpoint not implemented. Please contact backend team to create /add_platform_fee endpoint", "error");
//       }
//     } catch (error) {
//       console.error("Save error:", error);
//       showToast("Network error while saving", "error");
//     } finally {
//       setSubmittingFee(false);
//     }
//   };

//   const handleToggleFeeStatus = async (fee) => {
//     const newStatus = fee.status === "1" ? "0" : "1";
    
//     setSubmittingFee(true);
//     try {
//       const result = await postData("platformfee/update_platform_fee_status", {
//         id: fee.id,
//         status: newStatus
//       });
//       if (result.status) {
//         showToast(`Platform fee ${newStatus === "1" ? "activated" : "deactivated"} successfully`);
//         fetchAllPlatformFees();
//       } else {
//         showToast(result.message || "Status update failed", "error");
//       }
//     } catch (error) {
//       console.error("Status update error:", error);
//       showToast("Network error while updating status", "error");
//     } finally {
//       setSubmittingFee(false);
//     }
//   };

//   const filteredFees = platformFees.filter(fee => 
//     fee.user_fee?.toString().includes(searchFee) ||
//     fee.driver_fee?.toString().includes(searchFee) ||
//     fee.business_fee?.toString().includes(searchFee) ||
//     fee.status?.toString().includes(searchFee)
//   );

//   // ===================== PLATFORM CHARGES FUNCTIONS =====================
//   const fetchPlatformCharges = async () => {
//     setLoadingCharge(true);
//     try {
//       const result = await getData("PlatformFee/get_platform_charges");
//       if (result.status) {
//         setPlatformCharges(result.data);
//       } else {
//         showToast(result.message || "Failed to fetch platform charges", "error");
//       }
//     } catch (error) {
//       console.error("Fetch error:", error);
//       showToast("Network error while fetching platform charges", "error");
//     } finally {
//       setLoadingCharge(false);
//     }
//   };

//   const handleOpenChargeModal = (charge = null) => {
//     if (charge) {
//       setEditingCharge(charge);
//       setChargeFormData({
//         id: charge.id,
//         platform_fee: charge.platform_fee || "",
//         handling_charge: charge.handling_charge || "",
//         shipping_charge: charge.shipping_charge || "",
//         gst: charge.gst || "5.00",
//         status: charge.status || "1"
//       });
//     } else {
//       setEditingCharge(null);
//       setChargeFormData({
//         platform_fee: "",
//         handling_charge: "",
//         shipping_charge: "",
//         gst: "5.00",
//         status: "1"
//       });
//     }
//     setShowChargeModal(true);
//   };

//   // ===================== ADD PLATFORM CHARGE API =====================
//   const handleSaveCharge = async () => {
//     // Validation
//     if (!chargeFormData.platform_fee && !chargeFormData.handling_charge && !chargeFormData.shipping_charge) {
//       showToast("At least one charge field is required", "error");
//       return;
//     }

//     setSubmittingCharge(true);
    
//     try {
//       // Prepare data for API
//       const payload = {
//         platform_fee: chargeFormData.platform_fee || "0.00",
//         handling_charge: chargeFormData.handling_charge || "0.00",
//         shipping_charge: chargeFormData.shipping_charge || "0.00",
//         gst: chargeFormData.gst || "5.00",
//         status: chargeFormData.status || "1"
//       };

//       if (editingCharge) {
//         // Update existing charge
//         const updatePayload = {
//           id: editingCharge.id,
//           ...payload
//         };
//         const result = await postData("PlatformFee/update_platform_charge", updatePayload);
//         if (result.status) {
//           showToast("Platform charge updated successfully");
//           fetchPlatformCharges();
//           setShowChargeModal(false);
//         } else {
//           showToast(result.message || "Update failed", "error");
//         }
//       } else {
//         // Add new charge
//         const result = await postData("PlatformFee/add_platform_charges", payload);
//         if (result.status) {
//           showToast("Platform charge added successfully");
//           fetchPlatformCharges();
//           setShowChargeModal(false);
//           // Reset form
//           setChargeFormData({
//             platform_fee: "",
//             handling_charge: "",
//             shipping_charge: "",
//             gst: "5.00",
//             status: "1"
//           });
//         } else {
//           showToast(result.message || "Failed to add platform charge", "error");
//         }
//       }
//     } catch (error) {
//       console.error("Save error:", error);
//       showToast("Network error while saving", "error");
//     } finally {
//       setSubmittingCharge(false);
//     }
//   };

//   const handleToggleChargeStatus = async (charge) => {
//     const newStatus = charge.status === "1" ? "0" : "1";
    
//     setSubmittingCharge(true);
//     try {
//       const result = await postData("PlatformFee/update_platform_charge_status", {
//         id: charge.id,
//         status: newStatus
//       });
//       if (result.status) {
//         showToast(`Platform charge ${newStatus === "1" ? "activated" : "deactivated"} successfully`);
//         fetchPlatformCharges();
//       } else {
//         showToast(result.message || "Status update failed", "error");
//       }
//     } catch (error) {
//       console.error("Status update error:", error);
//       showToast("Network error while updating status", "error");
//     } finally {
//       setSubmittingCharge(false);
//     }
//   };

//   // Filter charges by GST percentage
//   const foodCharges = platformCharges.filter(charge => parseFloat(charge.gst) === 5);
//   const otherCharges = platformCharges.filter(charge => parseFloat(charge.gst) === 18);

//   const filteredFoodCharges = foodCharges.filter(charge => 
//     charge.platform_fee?.toString().includes(searchCharge) ||
//     charge.handling_charge?.toString().includes(searchCharge) ||
//     charge.shipping_charge?.toString().includes(searchCharge) ||
//     charge.gst?.toString().includes(searchCharge) ||
//     charge.status?.toString().includes(searchCharge)
//   );

//   const filteredOtherCharges = otherCharges.filter(charge => 
//     charge.platform_fee?.toString().includes(searchCharge) ||
//     charge.handling_charge?.toString().includes(searchCharge) ||
//     charge.shipping_charge?.toString().includes(searchCharge) ||
//     charge.gst?.toString().includes(searchCharge) ||
//     charge.status?.toString().includes(searchCharge)
//   );

//   // ===================== STYLES =====================
//   const styles = {
//     container: {
//       minHeight: "100vh",
//       background: t.bg,
//       fontFamily: "'DM Sans', sans-serif",
//       padding: isMobile ? "16px" : "24px",
//     },
//     contentWrapper: {
//       maxWidth: "1200px",
//       margin: "0 auto",
//     },
//     header: {
//       marginBottom: "28px",
//     },
//     title: {
//       fontSize: isMobile ? "22px" : "28px",
//       fontWeight: 700,
//       background: "linear-gradient(135deg, #6c63ff, #a855f7)",
//       WebkitBackgroundClip: "text",
//       WebkitTextFillColor: "transparent",
//       margin: 0,
//     },
//     subtitle: {
//       fontSize: "13px",
//       color: t.textMuted,
//       marginTop: "6px",
//     },
//     card: {
//       background: t.surface,
//       border: `1px solid ${t.border}`,
//       borderRadius: "20px",
//       overflow: "hidden",
//       marginBottom: "30px",
//     },
//     cardHeader: {
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       padding: "16px 20px",
//       borderBottom: `1px solid ${t.border}`,
//       background: t.surfaceAlt,
//       flexWrap: "wrap",
//       gap: "12px",
//     },
//     cardTitle: {
//       fontSize: "16px",
//       fontWeight: 700,
//       color: t.text,
//       margin: 0,
//     },
//     searchWrapper: {
//       position: "relative",
//       width: isMobile ? "100%" : "260px",
//     },
//     searchInput: {
//       width: "100%",
//       padding: "10px 12px 10px 35px",
//       background: t.surface,
//       border: `1px solid ${t.border}`,
//       borderRadius: "12px",
//       fontSize: "13px",
//       color: t.text,
//       outline: "none",
//     },
//     addButton: {
//       display: "flex",
//       alignItems: "center",
//       gap: "6px",
//       padding: "8px 16px",
//       background: "linear-gradient(135deg, #6c63ff, #a855f7)",
//       border: "none",
//       borderRadius: "12px",
//       color: "#fff",
//       fontSize: "13px",
//       fontWeight: 600,
//       cursor: "pointer",
//       transition: "all 0.2s",
//     },
//     refreshButton: {
//       display: "flex",
//       alignItems: "center",
//       gap: "6px",
//       padding: "8px 12px",
//       background: t.surfaceAlt,
//       border: `1px solid ${t.border}`,
//       borderRadius: "12px",
//       color: t.text,
//       fontSize: "13px",
//       cursor: "pointer",
//       transition: "all 0.2s",
//     },
//     headerActions: {
//       display: "flex",
//       gap: "10px",
//       alignItems: "center",
//       flexWrap: "wrap",
//     },
//     tableWrapper: {
//       overflowX: "auto",
//     },
//     table: {
//       width: "100%",
//       borderCollapse: "collapse",
//       minWidth: "600px",
//     },
//     th: {
//       padding: "14px 16px",
//       textAlign: "left",
//       fontSize: "12px",
//       fontWeight: 700,
//       color: t.accent,
//       borderBottom: `1px solid ${t.border}`,
//       background: t.surfaceAlt,
//     },
//     td: {
//       padding: "14px 16px",
//       fontSize: "13px",
//       color: t.textSub,
//       borderBottom: `1px solid ${t.border}`,
//     },
//     actionButtons: {
//       display: "flex",
//       gap: "8px",
//       alignItems: "center",
//       flexWrap: "wrap",
//     },
//     editBtn: {
//       padding: "5px 12px",
//       borderRadius: "8px",
//       border: "none",
//       fontSize: "11px",
//       fontWeight: 500,
//       cursor: "pointer",
//       background: t.info,
//       color: "#fff",
//     },
//     toggleBtn: (isActive) => ({
//       padding: "5px 12px",
//       borderRadius: "20px",
//       border: "none",
//       fontSize: "11px",
//       fontWeight: 500,
//       cursor: "pointer",
//       background: isActive ? t.success : t.warning,
//       color: "#fff",
//     }),
//     modalOverlay: {
//       position: "fixed",
//       inset: 0,
//       zIndex: 200,
//       background: "rgba(0,0,0,0.6)",
//       backdropFilter: "blur(8px)",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//     },
//     modal: {
//       background: t.surface,
//       border: `1px solid ${t.border}`,
//       borderRadius: "24px",
//       width: isMobile ? "90%" : "500px",
//       maxHeight: "85vh",
//       overflow: "auto",
//     },
//     modalHeader: {
//       padding: "20px 24px",
//       borderBottom: `1px solid ${t.border}`,
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//     },
//     modalTitle: {
//       fontSize: "18px",
//       fontWeight: 700,
//       color: t.text,
//     },
//     modalBody: {
//       padding: "24px",
//     },
//     modalFooter: {
//       padding: "16px 24px",
//       borderTop: `1px solid ${t.border}`,
//       display: "flex",
//       gap: "12px",
//       justifyContent: "flex-end",
//     },
//     formGroup: {
//       marginBottom: "20px",
//     },
//     label: {
//       display: "block",
//       fontSize: "12px",
//       fontWeight: 600,
//       color: t.textMuted,
//       marginBottom: "6px",
//     },
//     input: {
//       width: "100%",
//       padding: "10px 14px",
//       background: t.surfaceAlt,
//       border: `1px solid ${t.border}`,
//       borderRadius: "12px",
//       fontSize: "13px",
//       color: t.text,
//       outline: "none",
//       fontFamily: "inherit",
//     },
//     select: {
//       width: "100%",
//       padding: "10px 14px",
//       background: t.surfaceAlt,
//       border: `1px solid ${t.border}`,
//       borderRadius: "12px",
//       fontSize: "13px",
//       color: t.text,
//       outline: "none",
//       cursor: "pointer",
//     },
//     cancelBtn: {
//       padding: "10px 20px",
//       background: t.surfaceAlt,
//       border: `1px solid ${t.border}`,
//       borderRadius: "12px",
//       color: t.text,
//       cursor: "pointer",
//     },
//     saveBtn: {
//       padding: "10px 20px",
//       background: "linear-gradient(135deg, #6c63ff, #a855f7)",
//       border: "none",
//       borderRadius: "12px",
//       color: "#fff",
//       cursor: "pointer",
//       fontWeight: 600,
//     },
//     rowCount: {
//       padding: "12px 20px",
//       borderTop: `1px solid ${t.border}`,
//       fontSize: "12px",
//       color: t.textMuted,
//     },
//     loadingText: {
//       textAlign: "center",
//       padding: "40px",
//       color: t.textMuted,
//     },
//     feeValue: {
//       display: "inline-block",
//       padding: "4px 10px",
//       borderRadius: "20px",
//       background: t.accent + "15",
//       color: t.accent,
//       fontWeight: 600,
//       fontSize: "12px",
//     },
//     divider: {
//       margin: "40px 0",
//       border: "none",
//       borderTop: `2px dashed ${t.border}`,
//     },
//     sectionHeader: {
//       fontSize: "20px",
//       fontWeight: 700,
//       color: t.text,
//       marginBottom: "20px",
//       paddingBottom: "10px",
//       borderBottom: `2px solid ${t.accent}`,
//       display: "flex",
//       alignItems: "center",
//       gap: "10px",
//     }
//   };

//   // ===================== RENDER =====================
//   return (
//     <div style={styles.container}>
//       <div style={styles.contentWrapper}>
//         {/* ========== MAIN HEADER ========== */}
//         <div style={styles.header}>
//           <h1 style={styles.title}>🏦 Platform Fee & Charges Management</h1>
//           <p style={styles.subtitle}>Configure platform fees, charges, handling, shipping & GST</p>
//         </div>

//         {/* ============================================================ */}
//         {/* ========== SECTION 1: PLATFORM FEE TABLE ========== */}
//         {/* ============================================================ */}
//         <div style={styles.sectionHeader}>
//           💰 Platform Fee Configuration
//           <span style={{ fontSize: "13px", fontWeight: 400, color: t.textMuted, marginLeft: "auto" }}>
//             Manage user, driver & business fees
//           </span>
//         </div>

//         <div style={styles.card}>
//           <div style={styles.cardHeader}>
//             <h3 style={styles.cardTitle}>Platform Fee Settings</h3>
//             <div style={styles.headerActions}>
//               <div style={styles.searchWrapper}>
//                 <span style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)" }}><SearchIcon /></span>
//                 <input 
//                   style={styles.searchInput} 
//                   placeholder="Search fees..." 
//                   value={searchFee} 
//                   onChange={(e) => setSearchFee(e.target.value)} 
//                 />
//               </div>
//               <button style={styles.addButton} onClick={() => handleOpenFeeModal()}>
//                 <PlusIcon /> Add Fee
//               </button>
//             </div>
//           </div>

//           <div style={styles.tableWrapper}>
//             {loadingFee ? (
//               <div style={styles.loadingText}>Loading platform fees...</div>
//             ) : (
//               <table style={styles.table}>
//                 <thead>
//                   <tr>
//                     <th style={styles.th}>SN</th>
//                     <th style={styles.th}>ID</th>
//                     <th style={styles.th}>User Fee</th>
//                     <th style={styles.th}>Driver Fee</th>
//                     <th style={styles.th}>Business Fee</th>
//                     <th style={styles.th}>Status</th>
//                     <th style={styles.th}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredFees.length > 0 ? (
//                     filteredFees.map((fee, index) => (
//                       <tr key={fee.id}>
//                         <td style={styles.td}>{index + 1}</td>
//                         <td style={styles.td}>{fee.id}</td>
//                         <td style={styles.td}>
//                           <span style={styles.feeValue}>{fee.user_fee}</span>
//                         </td>
//                         <td style={styles.td}>
//                           <span style={styles.feeValue}>{fee.driver_fee}</span>
//                         </td>
//                         <td style={styles.td}>
//                           <span style={styles.feeValue}>{fee.business_fee || 0}</span>
//                         </td>
//                         <td style={styles.td}><StatusBadge status={fee.status} isDark={isDark} /></td>
//                         <td style={styles.td}>
//                           <div style={styles.actionButtons}>
//                             <button style={styles.editBtn} onClick={() => handleOpenFeeModal(fee)}>
//                               <EditIcon /> Edit
//                             </button>
//                             <button 
//                               style={styles.toggleBtn(fee.status === "1")} 
//                               onClick={() => handleToggleFeeStatus(fee)}
//                               disabled={submittingFee}
//                             >
//                               {fee.status === "1" ? "Deactivate" : "Activate"}
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="7" style={{ ...styles.td, textAlign: "center", padding: "40px" }}>
//                         {platformFees.length === 0 ? "No platform fees found" : "No matching fees found"}
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             )}
//           </div>

//           <div style={styles.rowCount}>
//             Rows: {filteredFees.length} of {platformFees.length} — Page 1/1
//           </div>
//         </div>

//         {/* ============================================================ */}
//         {/* ========== DIVIDER ========== */}
//         {/* ============================================================ */}
//         <hr style={styles.divider} />

//         {/* ============================================================ */}
//         {/* ========== SECTION 2: PLATFORM CHARGES TABLE ========== */}
//         {/* ============================================================ */}
//         <div style={styles.sectionHeader}>
//           💳 User Platform Charges
//           <span style={{ fontSize: "13px", fontWeight: 400, color: t.textMuted, marginLeft: "auto" }}>
//             Manage fees, handling, shipping & GST
//           </span>
//         </div>

//         <div style={styles.card}>
//           <div style={styles.cardHeader}>
//             <h3 style={styles.cardTitle}>Platform Charges Settings</h3>
//             <div style={styles.headerActions}>
//               <div style={styles.searchWrapper}>
//                 <span style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)" }}><SearchIcon /></span>
//                 <input 
//                   style={styles.searchInput} 
//                   placeholder="Search charges..." 
//                   value={searchCharge} 
//                   onChange={(e) => setSearchCharge(e.target.value)} 
//                 />
//               </div>
//               <button style={styles.refreshButton} onClick={fetchPlatformCharges}>
//                 <RefreshIcon /> Refresh
//               </button>
//               <button style={styles.addButton} onClick={() => handleOpenChargeModal()}>
//                 <PlusIcon /> Add Charge
//               </button>
//             </div>
//           </div>

//           <div style={styles.tableWrapper}>
//             {loadingCharge ? (
//               <div style={styles.loadingText}>Loading platform charges...</div>
//             ) : (
//               <>
//                 {/* Food Items Section - 5% GST (Green) */}
//                 <ChargeTable 
//                   title="Food Items"
//                   icon={<FoodIcon />}
//                   charges={filteredFoodCharges}
//                   isDark={isDark}
//                   onEdit={handleOpenChargeModal}
//                   onToggle={handleToggleChargeStatus}
//                   submitting={submittingCharge}
//                   gstColor="green"
//                   gstPercentage="5"
//                 />

//                 {/* Others Section - 18% GST (Yellow) */}
//                 <ChargeTable 
//                   title="Others Items"
//                   icon={<OthersIcon />}
//                   charges={filteredOtherCharges}
//                   isDark={isDark}
//                   onEdit={handleOpenChargeModal}
//                   onToggle={handleToggleChargeStatus}
//                   submitting={submittingCharge}
//                   gstColor="yellow"
//                   gstPercentage="18"
//                 />

//                 {/* Total count */}
//                 <div style={{ 
//                   padding: "12px 20px", 
//                   borderTop: `1px solid ${t.border}`,
//                   fontSize: "12px", 
//                   color: t.textMuted,
//                   display: "flex",
//                   justifyContent: "space-between",
//                   flexWrap: "wrap",
//                   gap: "10px"
//                 }}>
//                   <span>
//                     <span style={{ color: t.success }}>🍽️ Food (5% GST): {filteredFoodCharges.length}</span>
//                     {' | '}
//                     <span style={{ color: t.warning }}>📦 Others (18% GST): {filteredOtherCharges.length}</span>
//                   </span>
//                   <span>Total: {platformCharges.length} — Page 1/1</span>
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* ============================================================ */}
//       {/* ========== MODAL 1: PLATFORM FEE ========== */}
//       {/* ============================================================ */}
//       {showFeeModal && (
//         <div style={styles.modalOverlay} onClick={() => setShowFeeModal(false)}>
//           <div style={styles.modal} onClick={e => e.stopPropagation()}>
//             <div style={styles.modalHeader}>
//               <div style={styles.modalTitle}>{editingFee ? "Edit Platform Fee" : "Add New Platform Fee"}</div>
//               <button onClick={() => setShowFeeModal(false)} style={{ background: "none", border: "none", cursor: "pointer", color: t.textMuted }}>
//                 <CloseIcon />
//               </button>
//             </div>
//             <div style={styles.modalBody}>
//               {editingFee ? (
//                 <>
//                   <div style={styles.formGroup}>
//                     <label style={styles.label}>User Fee</label>
//                     <input 
//                       type="number" 
//                       style={{ ...styles.input, opacity: 0.6, cursor: "not-allowed" }} 
//                       value={feeFormData.user_fee} 
//                       disabled
//                     />
//                     <small style={{ color: t.textMuted, fontSize: "10px", marginTop: "4px", display: "block" }}>
//                       User fee can only be updated via database
//                     </small>
//                   </div>
//                   <div style={styles.formGroup}>
//                     <label style={styles.label}>Driver Fee</label>
//                     <input 
//                       type="number" 
//                       style={{ ...styles.input, opacity: 0.6, cursor: "not-allowed" }} 
//                       value={feeFormData.driver_fee} 
//                       disabled
//                     />
//                     <small style={{ color: t.textMuted, fontSize: "10px", marginTop: "4px", display: "block" }}>
//                       Driver fee can only be updated via database
//                     </small>
//                   </div>
//                   <div style={styles.formGroup}>
//                     <label style={styles.label}>Business Fee</label>
//                     <input 
//                       type="number" 
//                       style={{ ...styles.input, opacity: 0.6, cursor: "not-allowed" }} 
//                       value={feeFormData.business_fee} 
//                       disabled
//                     />
//                   </div>
//                   <div style={styles.formGroup}>
//                     <label style={styles.label}>Status</label>
//                     <select style={styles.select} value={feeFormData.status} onChange={(e) => setFeeFormData({ ...feeFormData, status: e.target.value })}>
//                       <option value="1">Active</option>
//                       <option value="0">Inactive</option>
//                     </select>
//                   </div>
//                 </>
//               ) : (
//                 <div style={{ textAlign: "center", padding: "20px" }}>
//                   <p style={{ color: t.warning }}>⚠️ Add endpoint not available</p>
//                   <p style={{ fontSize: "12px", color: t.textMuted, marginTop: "8px" }}>
//                     Please contact backend team to implement:<br />
//                     POST /platformfee/add_platform_fee
//                   </p>
//                 </div>
//               )}
//             </div>
//             <div style={styles.modalFooter}>
//               <button style={styles.cancelBtn} onClick={() => setShowFeeModal(false)}>Cancel</button>
//               {editingFee && (
//                 <button style={styles.saveBtn} onClick={handleSaveFee} disabled={submittingFee}>
//                   {submittingFee ? "Updating..." : "Update Status"}
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ============================================================ */}
//       {/* ========== MODAL 2: PLATFORM CHARGES ========== */}
//       {/* ============================================================ */}
//       {showChargeModal && (
//         <div style={styles.modalOverlay} onClick={() => setShowChargeModal(false)}>
//           <div style={styles.modal} onClick={e => e.stopPropagation()}>
//             <div style={styles.modalHeader}>
//               <div style={styles.modalTitle}>{editingCharge ? "Edit Platform Charge" : "Add New Platform Charge"}</div>
//               <button onClick={() => setShowChargeModal(false)} style={{ background: "none", border: "none", cursor: "pointer", color: t.textMuted }}>
//                 <CloseIcon />
//               </button>
//             </div>
//             <div style={styles.modalBody}>
//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Platform Fee (₹)</label>
//                 <input 
//                   type="number" 
//                   style={styles.input} 
//                   value={chargeFormData.platform_fee} 
//                   onChange={(e) => setChargeFormData({ ...chargeFormData, platform_fee: e.target.value })}
//                   placeholder="0.00"
//                   step="0.01"
//                   min="0"
//                 />
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Handling Charge (%)</label>
//                 <input 
//                   type="number" 
//                   style={styles.input} 
//                   value={chargeFormData.handling_charge} 
//                   onChange={(e) => setChargeFormData({ ...chargeFormData, handling_charge: e.target.value })}
//                   placeholder="0.00"
//                   step="0.01"
//                   min="0"
//                 />
//                 <small style={{ color: t.textMuted, fontSize: "10px", marginTop: "4px", display: "block" }}>
//                   Enter handling charge as percentage (e.g., 5.00 for 5%)
//                 </small>
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Shipping Charge (₹)</label>
//                 <input 
//                   type="number" 
//                   style={styles.input} 
//                   value={chargeFormData.shipping_charge} 
//                   onChange={(e) => setChargeFormData({ ...chargeFormData, shipping_charge: e.target.value })}
//                   placeholder="0.00"
//                   step="0.01"
//                   min="0"
//                 />
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label}>GST (%)</label>
//                 <input 
//                   type="number" 
//                   style={styles.input}
//                   value={chargeFormData.gst} 
//                   onChange={(e) => setChargeFormData({ ...chargeFormData, gst: e.target.value })}
//                   placeholder="5.00"
//                   step="0.01"
//                   min="0"
//                 />
//                 <small style={{ 
//                   color: parseFloat(chargeFormData.gst) === 5 ? t.success : parseFloat(chargeFormData.gst) === 18 ? t.warning : t.textMuted,
//                   fontSize: "10px", 
//                   marginTop: "4px", 
//                   display: "block",
//                   fontWeight: 500
//                 }}>
//                   {parseFloat(chargeFormData.gst) === 5 ? "🍽️ 5% GST - Food Items" : 
//                    parseFloat(chargeFormData.gst) === 18 ? "📦 18% GST - Others Items" : 
//                    "Enter 5% for Food or 18% for Others"}
//                 </small>
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Status</label>
//                 <select 
//                   style={styles.select} 
//                   value={chargeFormData.status} 
//                   onChange={(e) => setChargeFormData({ ...chargeFormData, status: e.target.value })}
//                 >
//                   <option value="1">Active</option>
//                   <option value="0">Inactive</option>
//                 </select>
//               </div>
//             </div>
//             <div style={styles.modalFooter}>
//               <button style={styles.cancelBtn} onClick={() => setShowChargeModal(false)}>Cancel</button>
//               <button style={styles.saveBtn} onClick={handleSaveCharge} disabled={submittingCharge}>
//                 {submittingCharge ? "Saving..." : editingCharge ? "Update" : "Add"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ============================================================ */}
//       {/* ========== TOAST NOTIFICATIONS ========== */}
//       {/* ============================================================ */}
//       {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} isDark={isDark} />}
//     </div>
//   );
// };

// export default PlatformFee;

import React, { useState, useEffect } from "react";
import { getData, serverURL, postData } from "../../../Services/Fetchnodeservices";

// ===================== THEME =====================
const getT = (isDark) => ({
  bg: isDark ? "#0c1018" : "#f0f4ff",
  surface: isDark ? "#141824" : "#ffffff",
  surfaceAlt: isDark ? "#1c2133" : "#f4f7ff",
  border: isDark ? "rgba(255,255,255,0.07)" : "#e2e8f5",
  text: isDark ? "#f1f5f9" : "#0f172a",
  textMuted: isDark ? "#64748b" : "#94a3b8",
  textSub: isDark ? "#94a3b8" : "#64748b",
  shadow: isDark ? "0 4px 28px rgba(0,0,0,0.45)" : "0 4px 28px rgba(99,102,241,0.10)",
  shadowSm: isDark ? "0 2px 10px rgba(0,0,0,0.35)" : "0 2px 10px rgba(99,102,241,0.07)",
  accent: "#6c63ff",
  success: "#22c55e",
  warning: "#f59e0b",
  danger: "#ef4444",
  info: "#3b82f6",
});

// ===================== ICONS =====================
const SearchIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
  </svg>
);

const PlusIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const RefreshIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M23 4v6h-6" />
    <path d="M1 20v-6h6" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" />
    <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14" />
  </svg>
);

const FoodIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2C10.5 2 9 3.5 9 5v2c0 1.5 1.5 3 3 3s3-1.5 3-3V5c0-1.5-1.5-3-3-3z" />
    <path d="M12 10v12" />
    <path d="M8 14h8" />
  </svg>
);

const OthersIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

// ===================== COMPONENTS =====================
const StatusBadge = ({ status, isDark }) => {
  const t = getT(isDark);
  const isActive = status === "1" || status === 1;
  const config = isActive
    ? { bg: "rgba(34,197,94,0.15)", color: t.success, label: "Active" }
    : { bg: "rgba(239,68,68,0.15)", color: t.danger, label: "Inactive" };
  return (
    <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: config.bg, color: config.color }}>
      {config.label}
    </span>
  );
};

const Toast = ({ message, type, onClose, isDark }) => {
  const t = getT(isDark);
  return (
    <div style={{ position: "fixed", bottom: "24px", right: "24px", zIndex: 1000, background: t.surface, border: `1px solid ${type === "error" ? t.danger : t.success}`, borderRadius: "12px", padding: "12px 20px", display: "flex", alignItems: "center", gap: "12px", boxShadow: t.shadow }}>
      <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: type === "error" ? t.danger : t.success }} />
      <span style={{ fontSize: "13px", color: type === "error" ? t.danger : t.success }}>{message}</span>
      <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: t.textMuted }}><CloseIcon /></button>
    </div>
  );
};

// ===================== SUB-COMPONENT: CHARGE TABLE =====================
const ChargeTable = ({ title, icon, charges, isDark, onEdit, onToggle, submitting, gstColor, gstPercentage }) => {
  const t = getT(isDark);

  const styles = {
    sectionTitle: {
      fontSize: "15px",
      fontWeight: 600,
      color: t.text,
      padding: "12px 20px",
      background: t.surfaceAlt,
      borderBottom: `2px solid ${t.accent}`,
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "750px",
    },
    th: {
      padding: "12px 16px",
      textAlign: "left",
      fontSize: "11px",
      fontWeight: 700,
      color: t.accent,
      borderBottom: `1px solid ${t.border}`,
      background: t.surfaceAlt,
    },
    td: {
      padding: "12px 16px",
      fontSize: "13px",
      color: t.textSub,
      borderBottom: `1px solid ${t.border}`,
    },
    actionButtons: {
      display: "flex",
      gap: "8px",
      alignItems: "center",
      flexWrap: "wrap",
    },
    editBtn: {
      padding: "5px 12px",
      borderRadius: "8px",
      border: "none",
      fontSize: "11px",
      fontWeight: 500,
      cursor: "pointer",
      background: t.info,
      color: "#fff",
    },
    toggleBtn: (isActive) => ({
      padding: "5px 12px",
      borderRadius: "20px",
      border: "none",
      fontSize: "11px",
      fontWeight: 500,
      cursor: "pointer",
      background: isActive ? t.success : t.warning,
      color: "#fff",
    }),
    chargeValue: {
      display: "inline-block",
      padding: "4px 10px",
      borderRadius: "20px",
      background: t.accent + "15",
      color: t.accent,
      fontWeight: 600,
      fontSize: "12px",
    },
    percentageValue: {
      display: "inline-block",
      padding: "4px 10px",
      borderRadius: "20px",
      background: "rgba(59, 130, 246, 0.15)",
      color: t.info,
      fontWeight: 600,
      fontSize: "12px",
    },
    gstValue: {
      display: "inline-block",
      padding: "4px 10px",
      borderRadius: "20px",
      background: gstColor === "green" ? "rgba(34, 197, 94, 0.15)" : "rgba(245, 158, 11, 0.15)",
      color: gstColor === "green" ? t.success : t.warning,
      fontWeight: 600,
      fontSize: "12px",
    },
    emptyState: {
      textAlign: "center",
      padding: "30px",
      color: t.textMuted,
      fontSize: "13px",
    },
    typeBadge: {
      display: "inline-block",
      padding: "2px 10px",
      borderRadius: "12px",
      fontSize: "10px",
      fontWeight: 600,
      background: title === "Food Items" ? "rgba(34, 197, 94, 0.15)" : "rgba(59, 130, 246, 0.15)",
      color: title === "Food Items" ? t.success : t.info,
    }
  };

  return (
    <>
      <div style={styles.sectionTitle}>
        {icon} {title}
        <span style={styles.typeBadge}>{charges.length} items</span>
        <span style={{
          marginLeft: "auto",
          fontSize: "11px",
          fontWeight: 400,
          color: t.textMuted,
          background: gstColor === "green" ? "rgba(34, 197, 94, 0.1)" : "rgba(245, 158, 11, 0.1)",
          padding: "2px 12px",
          borderRadius: "12px"
        }}>
          GST: {gstPercentage}%
        </span>
      </div>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>SN</th>
            <th style={styles.th}>ID</th>
            <th style={styles.th}>Platform Fee</th>
            <th style={styles.th}>Handling Charge</th>
            <th style={styles.th}>Shipping Charge</th>
            <th style={styles.th}>Order Receiving</th>

            <th style={styles.th}>GST</th>
            <th style={styles.th}>Status</th>
            <th style={styles.th}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {charges.length > 0 ? (
            charges.map((charge, index) => (
              <tr key={charge.id}>
                <td style={styles.td}>{index + 1}</td>
                <td style={styles.td}>{charge.id}</td>
                <td style={styles.td}>
                  <span style={styles.chargeValue}>₹{parseFloat(charge.platform_fee || 0).toFixed(2)}</span>
                </td>
                <td style={styles.td}>
                  <span style={styles.percentageValue}>
                    {parseFloat(charge.handling_charge || 0).toFixed(2)}%
                  </span>
                </td>
                <td style={styles.td}>
                  <span style={styles.chargeValue}>₹{parseFloat(charge.shipping_charge || 0).toFixed(2)}</span>
                </td>

                <td style={styles.td}>
  <span style={styles.chargeValue}>₹{parseFloat(charge.order_receiving_charge || 0).toFixed(2)}</span>
</td>
                <td style={styles.td}>
                  <span style={styles.gstValue}>
                    {parseFloat(charge.gst || 0).toFixed(2)}%
                  </span>
                </td>
                <td style={styles.td}><StatusBadge status={charge.status} isDark={isDark} /></td>
                <td style={styles.td}>
                  <div style={styles.actionButtons}>
                    <button style={styles.editBtn} onClick={() => onEdit(charge)}>
                      <EditIcon /> Edit
                    </button>
                    <button
                      style={styles.toggleBtn(charge.status === "1")}
                      onClick={() => onToggle(charge)}
                      disabled={submitting}
                    >
                      {charge.status === "1" ? "Deactivate" : "Activate"}
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={styles.emptyState}>
                No {title.toLowerCase()} found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

// ===================== MAIN COMPONENT =====================
const PlatformFee = ({ isDark = true }) => {
  const t = getT(isDark);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // ===== RESTAURANT PLATFORM FEE STATE =====
  const [searchRestaurant, setSearchRestaurant] = useState("");
  const [showRestaurantModal, setShowRestaurantModal] = useState(false);
  const [editingRestaurant, setEditingRestaurant] = useState(null);
  const [loadingRestaurant, setLoadingRestaurant] = useState(false);
  const [submittingRestaurant, setSubmittingRestaurant] = useState(false);
  const [restaurantFees, setRestaurantFees] = useState([]);
  const [restaurantFormData, setRestaurantFormData] = useState({
    platform_fee: "",
    handling_charge: "",
    shipping_charge: "",
      order_receiving_charge: "",   // नया

    gst: "5.00",
    status: "1"
  });

  // ===== USER PLATFORM CHARGES STATE =====
  const [searchCharge, setSearchCharge] = useState("");
  const [showChargeModal, setShowChargeModal] = useState(false);
  const [editingCharge, setEditingCharge] = useState(null);
  const [loadingCharge, setLoadingCharge] = useState(false);
  const [submittingCharge, setSubmittingCharge] = useState(false);
  const [platformCharges, setPlatformCharges] = useState([]);
  const [chargeFormData, setChargeFormData] = useState({
    platform_fee: "",
    handling_charge: "",
    shipping_charge: "",
    gst: "5.00",
    status: "1"
  });

  // ===== Toast =====
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    fetchRestaurantFees();
    fetchPlatformCharges();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3500);
  };

  // ===================== RESTAURANT FEE API =====================
  const fetchRestaurantFees = async () => {
    setLoadingRestaurant(true);
    try {
      const result = await getData("RestaurantPlatformFee/fetch_all_restaurant_fees");
      if (result.status) {
        setRestaurantFees(result.data);
      } else {
        showToast(result.message || "Failed to fetch restaurant fees", "error");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      showToast("Network error while fetching restaurant fees", "error");
    } finally {
      setLoadingRestaurant(false);
    }
  };

  const handleOpenRestaurantModal = (fee = null) => {
    if (fee) {
      setEditingRestaurant(fee);
      setRestaurantFormData({
        id: fee.id,
        platform_fee: fee.platform_fee || "",
        handling_charge: fee.handling_charge || "",
        shipping_charge: fee.shipping_charge || "",
            order_receiving_charge: fee.order_receiving_charge || "",  // नया

        gst: fee.gst || "5.00",
        status: fee.status || "1"
      });
    } else {
      setEditingRestaurant(null);
      setRestaurantFormData({
        platform_fee: "",
        handling_charge: "",
        shipping_charge: "",
        gst: "5.00",
        status: "1"
      });
    }
    setShowRestaurantModal(true);
  };

//   const handleSaveRestaurant = async () => {


// const payload = {
//   platform_fee: restaurantFormData.platform_fee || "0.00",
//   handling_charge: restaurantFormData.handling_charge || "0.00",
//   shipping_charge: restaurantFormData.shipping_charge || "0.00",
//   order_receiving_charge: restaurantFormData.order_receiving_charge || "0.00",  // नया
//   gst: restaurantFormData.gst || "5.00",
//   status: restaurantFormData.status || "1"
// };

//     if (!restaurantFormData.platform_fee && !restaurantFormData.handling_charge && !restaurantFormData.shipping_charge) {
//       showToast("At least one charge field is required", "error");
//       return;
//     }

//     setSubmittingRestaurant(true);
//     try {
//       const payload = {
//         platform_fee: restaurantFormData.platform_fee || "0.00",
//         handling_charge: restaurantFormData.handling_charge || "0.00",
//         shipping_charge: restaurantFormData.shipping_charge || "0.00",
//         gst: restaurantFormData.gst || "5.00",
//         status: restaurantFormData.status || "1"
//       };

//       if (editingRestaurant) {
//         const updatePayload = { id: editingRestaurant.id, ...payload };
//         const result = await postData("RestaurantPlatformFee/update_restaurant_fee", updatePayload);
//         if (result.status) {
//           showToast("Restaurant fee updated successfully");
//           fetchRestaurantFees();
//           setShowRestaurantModal(false);
//         } else {
//           showToast(result.message || "Update failed", "error");
//         }
//       } else {
//         const result = await postData("RestaurantPlatformFee/add_restaurant_fee", payload);
//         if (result.status) {
//           showToast("Restaurant fee added successfully");
//           fetchRestaurantFees();
//           setShowRestaurantModal(false);
//           setRestaurantFormData({
//             platform_fee: "",
//             handling_charge: "",
//             shipping_charge: "",
//             gst: "5.00",
//             status: "1"
//           });
//         } else {
//           showToast(result.message || "Failed to add restaurant fee", "error");
//         }
//       }
//     } catch (error) {
//       console.error("Save error:", error);
//       showToast("Network error while saving", "error");
//     } finally {
//       setSubmittingRestaurant(false);
//     }
//   };

const handleSaveRestaurant = async () => {
  // Validation – optional
  if (!restaurantFormData.platform_fee && !restaurantFormData.handling_charge && !restaurantFormData.shipping_charge && !restaurantFormData.order_receiving_charge) {
    showToast("At least one charge field is required", "error");
    return;
  }

  setSubmittingRestaurant(true);
  try {
    // ✅ सभी fields को payload में शामिल करो
    const payload = {
      platform_fee: restaurantFormData.platform_fee || "0.00",
      handling_charge: restaurantFormData.handling_charge || "0.00",
      shipping_charge: restaurantFormData.shipping_charge || "0.00",
      order_receiving_charge: restaurantFormData.order_receiving_charge || "0.00",  // ✅ ये missing था
      gst: restaurantFormData.gst || "5.00",
      status: restaurantFormData.status || "1"
    };

    if (editingRestaurant) {
      // Update के लिए id भी add करो
      const updatePayload = { id: editingRestaurant.id, ...payload };
      const result = await postData("RestaurantPlatformFee/update_restaurant_fee", updatePayload);
      if (result.status) {
        showToast("Restaurant fee updated successfully");
        fetchRestaurantFees();
        setShowRestaurantModal(false);
      } else {
        showToast(result.message || "Update failed", "error");
      }
    } else {
      // Add
      const result = await postData("RestaurantPlatformFee/add_restaurant_fee", payload);
      if (result.status) {
        showToast("Restaurant fee added successfully");
        fetchRestaurantFees();
        setShowRestaurantModal(false);
        // Reset form
        setRestaurantFormData({
          platform_fee: "",
          handling_charge: "",
          shipping_charge: "",
          order_receiving_charge: "",
          gst: "5.00",
          status: "1"
        });
      } else {
        showToast(result.message || "Failed to add restaurant fee", "error");
      }
    }
  } catch (error) {
    console.error("Save error:", error);
    showToast("Network error while saving", "error");
  } finally {
    setSubmittingRestaurant(false);
  }
};

  const handleToggleRestaurantStatus = async (fee) => {
    const newStatus = fee.status === "1" ? "0" : "1";
    setSubmittingRestaurant(true);
    try {
      const result = await postData("RestaurantPlatformFee/update_restaurant_fee_status", {
        id: fee.id,
        status: newStatus
      });
      if (result.status) {
        showToast(`Restaurant fee ${newStatus === "1" ? "activated" : "deactivated"} successfully`);
        fetchRestaurantFees();
      } else {
        showToast(result.message || "Status update failed", "error");
      }
    } catch (error) {
      console.error("Status update error:", error);
      showToast("Network error while updating status", "error");
    } finally {
      setSubmittingRestaurant(false);
    }
  };

  const filteredRestaurantFees = restaurantFees.filter(fee =>
    fee.platform_fee?.toString().includes(searchRestaurant) ||
    fee.handling_charge?.toString().includes(searchRestaurant) ||
    fee.shipping_charge?.toString().includes(searchRestaurant) ||
    fee.gst?.toString().includes(searchRestaurant) ||
    fee.status?.toString().includes(searchRestaurant)
  );

  // ===================== USER CHARGES API (existing) =====================
  const fetchPlatformCharges = async () => {
    setLoadingCharge(true);
    try {
      const result = await getData("PlatformFee/get_platform_charges");
      if (result.status) {
        setPlatformCharges(result.data);
      } else {
        showToast(result.message || "Failed to fetch platform charges", "error");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      showToast("Network error while fetching platform charges", "error");
    } finally {
      setLoadingCharge(false);
    }
  };

  const handleOpenChargeModal = (charge = null) => {
    if (charge) {
      setEditingCharge(charge);
      setChargeFormData({
        id: charge.id,
        platform_fee: charge.platform_fee || "",
        handling_charge: charge.handling_charge || "",
        shipping_charge: charge.shipping_charge || "",
        gst: charge.gst || "5.00",
        status: charge.status || "1"
      });
    } else {
      setEditingCharge(null);
      setChargeFormData({
        platform_fee: "",
        handling_charge: "",
        shipping_charge: "",
        gst: "5.00",
        status: "1"
      });
    }
    setShowChargeModal(true);
  };

  const handleSaveCharge = async () => {
    if (!chargeFormData.platform_fee && !chargeFormData.handling_charge && !chargeFormData.shipping_charge) {
      showToast("At least one charge field is required", "error");
      return;
    }

    setSubmittingCharge(true);
    try {
      const payload = {
        platform_fee: chargeFormData.platform_fee || "0.00",
        handling_charge: chargeFormData.handling_charge || "0.00",
        shipping_charge: chargeFormData.shipping_charge || "0.00",
        gst: chargeFormData.gst || "5.00",
        status: chargeFormData.status || "1"
      };

      if (editingCharge) {
        const updatePayload = { id: editingCharge.id, ...payload };
        const result = await postData("PlatformFee/update_platform_charge", updatePayload);
        if (result.status) {
          showToast("Platform charge updated successfully");
          fetchPlatformCharges();
          setShowChargeModal(false);
        } else {
          showToast(result.message || "Update failed", "error");
        }
      } else {
        const result = await postData("PlatformFee/add_platform_charges", payload);
        if (result.status) {
          showToast("Platform charge added successfully");
          fetchPlatformCharges();
          setShowChargeModal(false);
          setChargeFormData({
            platform_fee: "",
            handling_charge: "",
            shipping_charge: "",
            gst: "5.00",
            status: "1"
          });
        } else {
          showToast(result.message || "Failed to add platform charge", "error");
        }
      }
    } catch (error) {
      console.error("Save error:", error);
      showToast("Network error while saving", "error");
    } finally {
      setSubmittingCharge(false);
    }
  };

  const handleToggleChargeStatus = async (charge) => {
    const newStatus = charge.status === "1" ? "0" : "1";
    setSubmittingCharge(true);
    try {
      const result = await postData("PlatformFee/update_platform_charge_status", {
        id: charge.id,
        status: newStatus
      });
      if (result.status) {
        showToast(`Platform charge ${newStatus === "1" ? "activated" : "deactivated"} successfully`);
        fetchPlatformCharges();
      } else {
        showToast(result.message || "Status update failed", "error");
      }
    } catch (error) {
      console.error("Status update error:", error);
      showToast("Network error while updating status", "error");
    } finally {
      setSubmittingCharge(false);
    }
  };

  const foodCharges = platformCharges.filter(charge => parseFloat(charge.gst) === 5);
  const otherCharges = platformCharges.filter(charge => parseFloat(charge.gst) === 18);
  const filteredFoodCharges = foodCharges.filter(charge =>
    charge.platform_fee?.toString().includes(searchCharge) ||
    charge.handling_charge?.toString().includes(searchCharge) ||
    charge.shipping_charge?.toString().includes(searchCharge) ||
    charge.gst?.toString().includes(searchCharge) ||
    charge.status?.toString().includes(searchCharge)
  );
  const filteredOtherCharges = otherCharges.filter(charge =>
    charge.platform_fee?.toString().includes(searchCharge) ||
    charge.handling_charge?.toString().includes(searchCharge) ||
    charge.shipping_charge?.toString().includes(searchCharge) ||
    charge.gst?.toString().includes(searchCharge) ||
    charge.status?.toString().includes(searchCharge)
  );

  // ===================== STYLES =====================
  const styles = {
    container: {
      minHeight: "100vh",
      background: t.bg,
      fontFamily: "'DM Sans', sans-serif",
      padding: isMobile ? "16px" : "24px",
    },
    contentWrapper: {
      maxWidth: "1200px",
      margin: "0 auto",
    },
    header: {
      marginBottom: "28px",
    },
    title: {
      fontSize: isMobile ? "22px" : "28px",
      fontWeight: 700,
      background: "linear-gradient(135deg, #6c63ff, #a855f7)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      margin: 0,
    },
    subtitle: {
      fontSize: "13px",
      color: t.textMuted,
      marginTop: "6px",
    },
    card: {
      background: t.surface,
      border: `1px solid ${t.border}`,
      borderRadius: "20px",
      overflow: "hidden",
      marginBottom: "30px",
    },
    cardHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px 20px",
      borderBottom: `1px solid ${t.border}`,
      background: t.surfaceAlt,
      flexWrap: "wrap",
      gap: "12px",
    },
    cardTitle: {
      fontSize: "16px",
      fontWeight: 700,
      color: t.text,
      margin: 0,
    },
    searchWrapper: {
      position: "relative",
      width: isMobile ? "100%" : "260px",
    },
    searchInput: {
      width: "100%",
      padding: "10px 12px 10px 35px",
      background: t.surface,
      border: `1px solid ${t.border}`,
      borderRadius: "12px",
      fontSize: "13px",
      color: t.text,
      outline: "none",
    },
    addButton: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "8px 16px",
      background: "linear-gradient(135deg, #6c63ff, #a855f7)",
      border: "none",
      borderRadius: "12px",
      color: "#fff",
      fontSize: "13px",
      fontWeight: 600,
      cursor: "pointer",
      transition: "all 0.2s",
    },
    refreshButton: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "8px 12px",
      background: t.surfaceAlt,
      border: `1px solid ${t.border}`,
      borderRadius: "12px",
      color: t.text,
      fontSize: "13px",
      cursor: "pointer",
      transition: "all 0.2s",
    },
    headerActions: {
      display: "flex",
      gap: "10px",
      alignItems: "center",
      flexWrap: "wrap",
    },
    tableWrapper: {
      overflowX: "auto",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "600px",
    },
    th: {
      padding: "14px 16px",
      textAlign: "left",
      fontSize: "12px",
      fontWeight: 700,
      color: t.accent,
      borderBottom: `1px solid ${t.border}`,
      background: t.surfaceAlt,
    },
    td: {
      padding: "14px 16px",
      fontSize: "13px",
      color: t.textSub,
      borderBottom: `1px solid ${t.border}`,
    },
    actionButtons: {
      display: "flex",
      gap: "8px",
      alignItems: "center",
      flexWrap: "wrap",
    },
    editBtn: {
      padding: "5px 12px",
      borderRadius: "8px",
      border: "none",
      fontSize: "11px",
      fontWeight: 500,
      cursor: "pointer",
      background: t.info,
      color: "#fff",
    },
    toggleBtn: (isActive) => ({
      padding: "5px 12px",
      borderRadius: "20px",
      border: "none",
      fontSize: "11px",
      fontWeight: 500,
      cursor: "pointer",
      background: isActive ? t.success : t.warning,
      color: "#fff",
    }),
    modalOverlay: {
      position: "fixed",
      inset: 0,
      zIndex: 200,
      background: "rgba(0,0,0,0.6)",
      backdropFilter: "blur(8px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modal: {
      background: t.surface,
      border: `1px solid ${t.border}`,
      borderRadius: "24px",
      width: isMobile ? "90%" : "500px",
      maxHeight: "85vh",
      overflow: "auto",
    },
    modalHeader: {
      padding: "20px 24px",
      borderBottom: `1px solid ${t.border}`,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    modalTitle: {
      fontSize: "18px",
      fontWeight: 700,
      color: t.text,
    },
    modalBody: {
      padding: "24px",
    },
    modalFooter: {
      padding: "16px 24px",
      borderTop: `1px solid ${t.border}`,
      display: "flex",
      gap: "12px",
      justifyContent: "flex-end",
    },
    formGroup: {
      marginBottom: "20px",
    },
    label: {
      display: "block",
      fontSize: "12px",
      fontWeight: 600,
      color: t.textMuted,
      marginBottom: "6px",
    },
    input: {
      width: "100%",
      padding: "10px 14px",
      background: t.surfaceAlt,
      border: `1px solid ${t.border}`,
      borderRadius: "12px",
      fontSize: "13px",
      color: t.text,
      outline: "none",
      fontFamily: "inherit",
    },
    select: {
      width: "100%",
      padding: "10px 14px",
      background: t.surfaceAlt,
      border: `1px solid ${t.border}`,
      borderRadius: "12px",
      fontSize: "13px",
      color: t.text,
      outline: "none",
      cursor: "pointer",
    },
    cancelBtn: {
      padding: "10px 20px",
      background: t.surfaceAlt,
      border: `1px solid ${t.border}`,
      borderRadius: "12px",
      color: t.text,
      cursor: "pointer",
    },
    saveBtn: {
      padding: "10px 20px",
      background: "linear-gradient(135deg, #6c63ff, #a855f7)",
      border: "none",
      borderRadius: "12px",
      color: "#fff",
      cursor: "pointer",
      fontWeight: 600,
    },
    rowCount: {
      padding: "12px 20px",
      borderTop: `1px solid ${t.border}`,
      fontSize: "12px",
      color: t.textMuted,
    },
    loadingText: {
      textAlign: "center",
      padding: "40px",
      color: t.textMuted,
    },
    feeValue: {
      display: "inline-block",
      padding: "4px 10px",
      borderRadius: "20px",
      background: t.accent + "15",
      color: t.accent,
      fontWeight: 600,
      fontSize: "12px",
    },
    divider: {
      margin: "40px 0",
      border: "none",
      borderTop: `2px dashed ${t.border}`,
    },
    sectionHeader: {
      fontSize: "20px",
      fontWeight: 700,
      color: t.text,
      marginBottom: "20px",
      paddingBottom: "10px",
      borderBottom: `2px solid ${t.accent}`,
      display: "flex",
      alignItems: "center",
      gap: "10px",
    }
  };

  // ===================== RENDER =====================
  return (
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        {/* ========== HEADER ========== */}
        <div style={styles.header}>
          <h1 style={styles.title}>🏦 Restaurant & User Fee Management</h1>
          <p style={styles.subtitle}>Configure platform fees, handling, shipping & GST for restaurants and users</p>
        </div>

        {/* ========== SECTION 1: RESTAURANT PLATFORM FEE ========== */}
        <div style={styles.sectionHeader}>
          🍽️ Restaurant Platform Fee
          <span style={{ fontSize: "13px", fontWeight: 400, color: t.textMuted, marginLeft: "auto" }}>
            Manage restaurant‑specific fees, handling & GST
          </span>
        </div>

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <h3 style={styles.cardTitle}>Restaurant Fee Settings</h3>
            <div style={styles.headerActions}>
              <div style={styles.searchWrapper}>
                <span style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)" }}><SearchIcon /></span>
                <input
                  style={styles.searchInput}
                  placeholder="Search fees..."
                  value={searchRestaurant}
                  onChange={(e) => setSearchRestaurant(e.target.value)}
                />
              </div>
              <button style={styles.addButton} onClick={() => handleOpenRestaurantModal()}>
                <PlusIcon /> Add Fee
              </button>
            </div>
          </div>

          <div style={styles.tableWrapper}>
            {loadingRestaurant ? (
              <div style={styles.loadingText}>Loading restaurant fees...</div>
            ) : (
              <ChargeTable
                title="Restaurant Fees"
                icon={<FoodIcon />}
                charges={filteredRestaurantFees}
                isDark={isDark}
                onEdit={handleOpenRestaurantModal}
                onToggle={handleToggleRestaurantStatus}
                submitting={submittingRestaurant}
                gstColor="green"
                gstPercentage="All"
              />
            )}
          </div>

          <div style={styles.rowCount}>
            Rows: {filteredRestaurantFees.length} of {restaurantFees.length} — Page 1/1
          </div>
        </div>

        {/* ========== DIVIDER ========== */}
        <hr style={styles.divider} />

        {/* ========== SECTION 2: USER PLATFORM CHARGES ========== */}
        <div style={styles.sectionHeader}>
          💳 User Platform Charges
          <span style={{ fontSize: "13px", fontWeight: 400, color: t.textMuted, marginLeft: "auto" }}>
            Manage user fees, handling, shipping & GST
          </span>
        </div>

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <h3 style={styles.cardTitle}>Platform Charges Settings</h3>
            <div style={styles.headerActions}>
              <div style={styles.searchWrapper}>
                <span style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)" }}><SearchIcon /></span>
                <input
                  style={styles.searchInput}
                  placeholder="Search charges..."
                  value={searchCharge}
                  onChange={(e) => setSearchCharge(e.target.value)}
                />
              </div>
              <button style={styles.refreshButton} onClick={fetchPlatformCharges}>
                <RefreshIcon /> Refresh
              </button>
              <button style={styles.addButton} onClick={() => handleOpenChargeModal()}>
                <PlusIcon /> Add Charge
              </button>
            </div>
          </div>

          <div style={styles.tableWrapper}>
            {loadingCharge ? (
              <div style={styles.loadingText}>Loading platform charges...</div>
            ) : (
              <>
                <ChargeTable
                  title="Food Items"
                  icon={<FoodIcon />}
                  charges={filteredFoodCharges}
                  isDark={isDark}
                  onEdit={handleOpenChargeModal}
                  onToggle={handleToggleChargeStatus}
                  submitting={submittingCharge}
                  gstColor="green"
                  gstPercentage="5"
                />
                <ChargeTable
                  title="Others Items"
                  icon={<OthersIcon />}
                  charges={filteredOtherCharges}
                  isDark={isDark}
                  onEdit={handleOpenChargeModal}
                  onToggle={handleToggleChargeStatus}
                  submitting={submittingCharge}
                  gstColor="yellow"
                  gstPercentage="18"
                />
                <div style={{ padding: "12px 20px", borderTop: `1px solid ${t.border}`, fontSize: "12px", color: t.textMuted, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px" }}>
                  <span>
                    <span style={{ color: t.success }}>🍽️ Food (5% GST): {filteredFoodCharges.length}</span>
                    {' | '}
                    <span style={{ color: t.warning }}>📦 Others (18% GST): {filteredOtherCharges.length}</span>
                  </span>
                  <span>Total: {platformCharges.length} — Page 1/1</span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* ========== MODAL: RESTAURANT FEE ========== */}
      {showRestaurantModal && (
        <div style={styles.modalOverlay} onClick={() => setShowRestaurantModal(false)}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div style={styles.modalTitle}>{editingRestaurant ? "Edit Restaurant Fee" : "Add New Restaurant Fee"}</div>
              <button onClick={() => setShowRestaurantModal(false)} style={{ background: "none", border: "none", cursor: "pointer", color: t.textMuted }}>
                <CloseIcon />
              </button>
            </div>
            <div style={styles.modalBody}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Platform Fee (₹)</label>
                <input
                  type="number"
                  style={styles.input}
                  value={restaurantFormData.platform_fee}
                  onChange={(e) => setRestaurantFormData({ ...restaurantFormData, platform_fee: e.target.value })}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Handling Charge (%)</label>
                <input
                  type="number"
                  style={styles.input}
                  value={restaurantFormData.handling_charge}
                  onChange={(e) => setRestaurantFormData({ ...restaurantFormData, handling_charge: e.target.value })}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                />
                <small style={{ color: t.textMuted, fontSize: "10px", marginTop: "4px", display: "block" }}>
                  Enter handling charge as percentage (e.g., 5.00 for 5%)
                </small>
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Shipping Charge (₹)</label>
                <input
                  type="number"
                  style={styles.input}
                  value={restaurantFormData.shipping_charge}
                  onChange={(e) => setRestaurantFormData({ ...restaurantFormData, shipping_charge: e.target.value })}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                />
              </div>
<div style={styles.formGroup}>
  <label style={styles.label}>Order Receiving Charge (₹)</label>
  <input
    type="number"
    style={styles.input}
    value={restaurantFormData.order_receiving_charge}
    onChange={(e) => setRestaurantFormData({ ...restaurantFormData, order_receiving_charge: e.target.value })}
    placeholder="0.00"
    step="0.01"
    min="0"
  />
  <small style={{ color: t.textMuted, fontSize: "10px", marginTop: "4px", display: "block" }}>
    Charge for receiving orders
  </small>
</div>

              <div style={styles.formGroup}>
                <label style={styles.label}>GST (%)</label>
                <input
                  type="number"
                  style={styles.input}
                  value={restaurantFormData.gst}
                  onChange={(e) => setRestaurantFormData({ ...restaurantFormData, gst: e.target.value })}
                  placeholder="5.00"
                  step="0.01"
                  min="0"
                />
                <small style={{
                  color: parseFloat(restaurantFormData.gst) === 5 ? t.success : parseFloat(restaurantFormData.gst) === 18 ? t.warning : t.textMuted,
                  fontSize: "10px",
                  marginTop: "4px",
                  display: "block",
                  fontWeight: 500
                }}>
                  {parseFloat(restaurantFormData.gst) === 5 ? "🍽️ 5% GST - Food Items" :
                    parseFloat(restaurantFormData.gst) === 18 ? "📦 18% GST - Others Items" :
                    "Enter 5% for Food or 18% for Others"}
                </small>
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Status</label>
                <select
                  style={styles.select}
                  value={restaurantFormData.status}
                  onChange={(e) => setRestaurantFormData({ ...restaurantFormData, status: e.target.value })}
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
            </div>
            <div style={styles.modalFooter}>
              <button style={styles.cancelBtn} onClick={() => setShowRestaurantModal(false)}>Cancel</button>
              <button style={styles.saveBtn} onClick={handleSaveRestaurant} disabled={submittingRestaurant}>
                {submittingRestaurant ? "Saving..." : editingRestaurant ? "Update" : "Add"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ========== MODAL: USER CHARGE ========== */}
      {showChargeModal && (
        <div style={styles.modalOverlay} onClick={() => setShowChargeModal(false)}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div style={styles.modalTitle}>{editingCharge ? "Edit Platform Charge" : "Add New Platform Charge"}</div>
              <button onClick={() => setShowChargeModal(false)} style={{ background: "none", border: "none", cursor: "pointer", color: t.textMuted }}>
                <CloseIcon />
              </button>
            </div>
            <div style={styles.modalBody}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Platform Fee (₹)</label>
                <input
                  type="number"
                  style={styles.input}
                  value={chargeFormData.platform_fee}
                  onChange={(e) => setChargeFormData({ ...chargeFormData, platform_fee: e.target.value })}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Handling Charge (%)</label>
                <input
                  type="number"
                  style={styles.input}
                  value={chargeFormData.handling_charge}
                  onChange={(e) => setChargeFormData({ ...chargeFormData, handling_charge: e.target.value })}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                />
                <small style={{ color: t.textMuted, fontSize: "10px", marginTop: "4px", display: "block" }}>
                  Enter handling charge as percentage (e.g., 5.00 for 5%)
                </small>
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Shipping Charge (₹)</label>
                <input
                  type="number"
                  style={styles.input}
                  value={chargeFormData.shipping_charge}
                  onChange={(e) => setChargeFormData({ ...chargeFormData, shipping_charge: e.target.value })}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>GST (%)</label>
                <input
                  type="number"
                  style={styles.input}
                  value={chargeFormData.gst}
                  onChange={(e) => setChargeFormData({ ...chargeFormData, gst: e.target.value })}
                  placeholder="5.00"
                  step="0.01"
                  min="0"
                />
                <small style={{
                  color: parseFloat(chargeFormData.gst) === 5 ? t.success : parseFloat(chargeFormData.gst) === 18 ? t.warning : t.textMuted,
                  fontSize: "10px",
                  marginTop: "4px",
                  display: "block",
                  fontWeight: 500
                }}>
                  {parseFloat(chargeFormData.gst) === 5 ? "🍽️ 5% GST - Food Items" :
                    parseFloat(chargeFormData.gst) === 18 ? "📦 18% GST - Others Items" :
                    "Enter 5% for Food or 18% for Others"}
                </small>
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Status</label>
                <select
                  style={styles.select}
                  value={chargeFormData.status}
                  onChange={(e) => setChargeFormData({ ...chargeFormData, status: e.target.value })}
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
            </div>
            <div style={styles.modalFooter}>
              <button style={styles.cancelBtn} onClick={() => setShowChargeModal(false)}>Cancel</button>
              <button style={styles.saveBtn} onClick={handleSaveCharge} disabled={submittingCharge}>
                {submittingCharge ? "Saving..." : editingCharge ? "Update" : "Add"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ========== TOAST ========== */}
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} isDark={isDark} />}
    </div>
  );
};

export default PlatformFee;